import { Link } from "gatsby"
import React from "react"

export const hoverable_map_piece = ({ link, id, paths }) => {
  return (
    <Link key={link} to={link} id={id} className="bundesland">
      {paths?.map(({ title, d }) => (
        <path title={title} d={d} key={d} />
      ))}
    </Link>
  )
}

export const ClickableMap = ({
  viewBox = "-25 -25 650 850",
  border = undefined,
}) => {
  const all_states = [
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/baden-wuerttemberg",
      id: "BW",
      paths: [
        {
          title: "Baden-Württemberg",
          d: "m149.8 629.2-16.9 20.3-24.5 71.5.1 39.9h60.7l34.8-8.6 32.5 12.4 33.9-12.3-9.6-66.4 33.4-29.6-23.9-49.8-.1-30.2-20.6-21.7-30.5-3.5-13.8 18.4-17.4 8.3-17.8-2.9-9.8-5.6 5.7 27.8z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/bayern",
      id: "BY",
      paths: [
        {
          title: "Bayern",
          d: "m265 476.8-17.3 9.4-16 33-33.6 3.7 9.1 26.6-1.9 20.1 3.3-1 10.5-17.4 30.5 3.5 20.6 21.7.1 30.2 23.9 49.8-33.4 29.6 9.6 66.4-33.9 12.3 40.9 25.1 27-25.1 20.2 14.2 94.5-25.6 35.4 20.9-16.1-59.1 61.8-42.1.9-34.9-69.9-60.2-11.6-48.5-6.2-18.3-17.1-14.3-11.3-10.6-31.3-8.8-11.5 24.1z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/mecklenburg-vorpommern",

      id: "MV",
      paths: [
        {
          title: "Mecklenburg-Vorpommern",
          d: "m300.4 182.8 42.8 25.9 49.7-26.7 61.2 21.9 51.3-40.5 38.3 23.3-3.5-29.9-92.5-98.4-120.9 56.7-16.2 26.3 10.5 5.7z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/schleswig-holstein",
      id: "SH",
      paths: [
        {
          title: "Schleswig-Holstein",
          d: "m191.8 127.7 26.9 2.7 26.5 32v-8.5l6.7 5.4 21.3-16.2-.6 22.8 12.3 11 15.5 5.9 20.7-35.7-10.5-5.7 16.2-26.3 5.2-40-54.9-5.4L261 32l-38.3-6.8-29.9-16.3-24.5 2.1 18.6 38.8 15 13.3-28.3 11.5 16.1 27.6z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/niedersachsen",
      id: "NI",
      paths: [
        {
          title: "Niedersachsen",
          d: "m366.9 217.5-23.7-8.8-42.8-25.9L283 177l-28.5 2.4-9.3-17-26.5-32-26.9-2.7h-23.5l-.7 34.5L126 146l-39.6 4-15.5 26.2 14 32.4-10.6 47.9-24 15.5 24.5 28.9 35.3-24.1 22.7 14.2 4.3 27.8 23.8-4.3-5.7-30.4 21.3-13.3 3.5 14.1 24.6-10.7 18.1 87.5 20.2 35.2 64-34.5-8-17.4 7.9-24 17-1.3 6.9-32.3-19.6-48.8 34.9-4.4 20.9-16.7zM167.7 158l9.4-1.6-1.7 13.6-4.2.9-3.6-7.8.1-5.1zm26.9 63.1-13.8-2.7-14.6-20 6.9 1.7 25.9 9.5-4.4 11.5z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/nordrhein-westfalen",
      id: "NW",
      paths: [
        {
          title: "Nordrhein-Westphalen",
          d: "m222.7 361.7-17.8 21.1-30.3 11 6.4 23-38.1 43.1-19-19.8-31.4 24.5-24.5 7.6-9.6 20.2-25.1 3.8-3.1-16.1-21.4-45.3 2.8-78.9 63.2-55 35.3-24.1 22.7 14.2 4.3 27.8 23.8-4.3-5.7-30.4 21.3-13.3 3.5 14.1 24.6-10.7z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/rheinland-pfalz",
      id: "RP",
      paths: [
        {
          title: "Rheinland-Pfalz",
          d: "m142.9 459.9-8.3 27.8 7.1 14.7-21.2 20.1 7.1 8.5 19-6.3 12.5 16.5-.7 18.9 7.6 37.1-16.2 32-55.5-18.5 2.5-20.6-11.9-19.2-11.9-7.3-26.8 11.9-14.5-3.2 9.4-25.3-17.4-7.5-9.1-17.3 4.3-17.4 14.4-8.6 25.1-3.8 9.3-19.5 24.8-8.4 31.4-24.4z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/hessen",
      id: "HE",
      paths: [
        {
          title: "Hessen",
          d: "m142.9 459.9-8.3 27.8 7.1 14.7-21.2 20.1 7.1 8.5 19-6.3 12.5 16.5-.7 18.8 1.9 9.4 9.7 5.6 17.8 2.8 17.4-8.3 1.9-20.1-9-26.6 33.5-3.7 16-33 17.3-9.4-5.6-30.6s18.9-36.2 18-37c-.9-.8-19.8-20.2-19.8-20.2l-14.7 7.9-20.6-35.2-17.4 21.1-30.3 11 6.4 23-38 43.2z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/saarland",
      id: "SL",
      paths: [
        {
          title: "Saarland",
          d: "m94.3 610.7 2.5-20.6-11.9-19.2-11.9-7.3-26.8 11.9-14.5-3.2-.9 8 15.2 12 8.4 17.7 13.4-5.1 13.4 9.5 8.7.5z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/brandenburg",
      id: "BB",
      paths: [
        {
          title: "Brandenburg",
          d: "m555.1 344.2 7.8-42.5-11.4-16.5 6.6-18.5-32.9-27.9 20.7-44.9-2.2-7.2-15.3-9.3-22.9-14-51.4 40.5-61.2-21.9-49.7 26.7 23.7 8.8 12.9 9.2 22.5 7.8-.4 38.2 2 35.9 18.4 16.8 37.1 14.1-2.1 23.2 10.3 25.5 51.7 3.6 7-18.4 37.9-4.1-9.1-25.1zM495 291.1l-11.7-8.5-3.1 4.5-20.8-3.8 1.6-11 8.1-15L487 259l-.9 5.6 9.4 6.4-2.9 6.1 9.4 3.1-7 10.9z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/sachsen-anhalt",
      id: "ST",
      paths: [
        {
          title: "Sachsen-Anhalt",
          d: "M366.9 217.5 346 234.2l-34.9 4.4 19.6 48.8-6.9 32.3-17 1.3-7.9 24 8 17.4 18.8 23.3 20.9.8 10 11.7-7 7.7 54.1 28.5 4.3-15.3-3.4-48.2 52.7-8.3 2.1-23.2-37.1-14-18.4-16.8-2-34.4.4-39.7-22.5-7.8z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/sachsen",
      id: "SN",
      paths: [
        {
          title: "Sachsen",
          d: "M413.4 511.1 385 486.2l5.1-21.2 20.1-3-4.2-15.7 26.9-11.8-24.9-15.4-3.4-48.2 52.7-8.3 10.3 25.5 51.7 3.6 7-18.4 37.9-4.1 19.9 31.5-3.4 21.6-111.3 47-46.7 19.5z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/thueringen",
      id: "TH",
      paths: [
        {
          title: "Thüringen",
          d: "m257.6 388.9 19.8 20.3-18 37 5.6 30.6 77.2 24.7 11.5-24.1 31.3 8.8 5.1-21.2 20.1-3-4.2-15.7 26.9-11.8-24.9-15.4-4.3 15.3-54.1-28.5 7-7.7-10-11.7-20.9-.8-18.8-23.3z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/berlin",
      id: "BE",
      paths: [
        {
          title: "Berlin",
          d: "m502 280.2-9.4-3.1 2.9-6.1-9.4-6.4.9-5.6-17.9-1.7-8.1 15-1.6 11 20.8 3.8 3.1-4.5 11.7 8.5z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/bremen",
      id: "HB",
      paths: [
        {
          title: "Bremen",
          d: "m173.1 200.2-6.9-1.7 14.6 20 13.8 2.7 4.4-11.5z",
        },
        {
          title: "Bremen",
          d: "m175.4 170.1 1.7-13.6-9.4 1.6-.1 5.1 3.6 7.8z",
        },
      ],
    },
    {
      link: "/ausschreibungsdienste/ausschreibungen/region/hamburg",
      id: "HH",
      paths: [
        {
          title: "Hamburg",
          d: "m273.2 143.1-21.3 16.2-6.7-5.4v9.5l9.3 16 30.4-2.5-12.3-11z",
        },
      ],
    },
  ]

  return (
    <svg
      style={{ border: border }}
      viewBox={viewBox}
      xmlns="http://www.w3.org/2000/svg"
      xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      role="img"
    >
      {all_states.map((hoverable_state) =>
        hoverable_map_piece(hoverable_state)
      )}
      <text className="text-bundesland BY" transform="translate(340 650)">
        {"Bayern"}
      </text>
      <text className="text-bundesland BW" transform="translate(150 680)">
        {"Baden-"}
      </text>
      <text className="text-bundesland BW" transform="translate(150 704)">
        {"W\xFCrttemberg"}
      </text>
      <text className="text-bundesland BE" transform="translate(460 306)">
        {"Berlin"}
      </text>
      <text className="text-bundesland BB" transform="translate(420 235)">
        {"Brandenburg"}
      </text>
      <text className="text-bundesland HB" transform="translate(143 187)">
        {"Bremen"}
      </text>
      <text className="text-bundesland HH" transform="translate(226 197)">
        {"Hamburg"}
      </text>
      <text className="text-bundesland HE" transform="translate(170 470)">
        {"Hessen"}
      </text>
      <text className="text-bundesland MV" transform="translate(370 135)">
        {"Mecklenburg-"}
      </text>
      <text className="text-bundesland MV" transform="translate(370 159)">
        {"Vorpommern"}
      </text>
      <text className="text-bundesland NI" transform="translate(160 253)">
        {"Niedersachsen"}
      </text>
      <text className="text-bundesland NW" transform="translate(42 380)">
        {"Nordrhein-"}
      </text>
      <text className="text-bundesland NW" transform="translate(42 404)">
        {"Westfalen"}
      </text>
      <text className="text-bundesland RP" transform="translate(44 514)">
        {"Rheinland-"}
      </text>
      <text className="text-bundesland RP" transform="translate(44 538)">
        {"Pfalz"}
      </text>
      <text className="text-bundesland SL" transform="translate(18 630)">
        {"Saarland"}
      </text>
      <text className="text-bundesland SN" transform="translate(450 430)">
        {"Sachsen"}
      </text>
      <text className="text-bundesland ST" transform="translate(340 330)">
        {"Sachsen-"}
      </text>
      <text className="text-bundesland ST" transform="translate(340 354)">
        {"Anhalt"}
      </text>
      <text className="text-bundesland SH" transform="translate(220 100)">
        {"Schleswig-"}
      </text>
      <text className="text-bundesland SH" transform="translate(220 124)">
        {"Holstein"}
      </text>
      <text className="text-bundesland TH" transform="translate(293 450)">
        {"Th\xFCringen"}
      </text>
    </svg>
  )
}
